import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "image-container",
    style: _normalizeStyle({
      alignItems: $props.overlays > 1 ? 'flex-end' : 'center'
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.overlays, (_, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "overlap",
      key: index,
      style: _normalizeStyle($setup.overlayStyles[index])
    }, [index == 0 ? _renderSlot(_ctx.$slots, "default", {
      key: 0
    }, undefined, true) : _createCommentVNode("", true)], 4);
  }), 128)), $props.count ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "counter",
    style: _normalizeStyle({
      zIndex: $props.overlays - 1
    })
  }, _toDisplayString($props.count), 5)) : _createCommentVNode("", true)], 4);
}